var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.001,
    height: 22.001,
    viewBox: "0 0 24.001 22.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "warning",
    transform: "translate(0.001 -0.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21181",
    "data-name": "Path 21181",
    d: "M14.876,2.672a3.309,3.309,0,0,0-5.752,0L.414,18.19a3.178,3.178,0,0,0,.029,3.189A3.264,3.264,0,0,0,3.29,23H20.71a3.264,3.264,0,0,0,2.847-1.621,3.178,3.178,0,0,0,.029-3.189Zm6.955,17.7A1.283,1.283,0,0,1,20.71,21H3.29a1.283,1.283,0,0,1-1.121-.631,1.182,1.182,0,0,1-.011-1.2L10.868,3.65a1.355,1.355,0,0,1,2.264,0l8.71,15.518a1.182,1.182,0,0,1-.011,1.2Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21182",
    "data-name": "Path 21182",
    d: "M12,7a1,1,0,0,0-1,1v6a1,1,0,0,0,2,0V8A1,1,0,0,0,12,7Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_51",
    "data-name": "Ellipse 51",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(11 17)",
    fill: "#FF0000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.deb504e37b25527ffa51263c0d6cb900.svg";
export { ForwardRef as ReactComponent };